import HourTags from 'components/HourTags';
import React from 'react';
import type { TagBase } from 'types/tag';
import { type TagStyle, tagDisplay } from '../datatable.types';
import styles from './column.module.scss';
import { COLUMN_SIZE_MEDIUM } from './constants';
import HeaderWithMenu from './HeaderWithMenu';
import type { DatatableCellRenderer, DatatableColumnGetter } from './types';

interface TagParams {
  label?: string;
  tagStyle?: TagStyle;
}

export const getTagsColumn: DatatableColumnGetter<Array<TagBase>, TagParams> = (
  id: string,
  { tagStyle } = {}
) => ({
  id,
  header: props => (
    <HeaderWithMenu
      {...props}
      label="Tags"
      sortLabelType="string"
      filterTriggerSelector='[data-testid="tag-filter-dropdown"]'
    />
  ),
  minSize: COLUMN_SIZE_MEDIUM,
  size: COLUMN_SIZE_MEDIUM,
  enableResizing: true,
  enableSorting: false,
  meta: {
    numeric: false,
    label: tagStyle?.tagDisplay
      ? (() => {
          switch (tagStyle.tagDisplay) {
            case tagDisplay.Values.tagLists:
              return 'Tag list';
            case tagDisplay.Values.listsAndTags:
              return 'Tag list & tag';
            default:
              return 'Tag';
          }
        })()
      : 'Tag',
    labelPlural: tagStyle?.tagDisplay
      ? (() => {
          switch (tagStyle.tagDisplay) {
            case tagDisplay.Values.tagLists:
              return 'Tag lists';
            case tagDisplay.Values.listsAndTags:
              return 'Tag lists & tags';
            default:
              return 'Tags';
          }
        })()
      : 'Tags',
    getValue: (tags: Array<TagBase>) => {
      const uniqueIds = new Set<string>();

      tags.forEach(tag => {
        let id;
        switch (tagStyle?.tagDisplay) {
          case tagDisplay.Values.tagLists:
            id = `${tag.parent?.id}`;
            break;
          case tagDisplay.Values.listsAndTags:
            id = `${tag.parent?.id}-${tag.id}`;
            break;
          default:
            id = `${tag.id}`;
        }
        if (id) {
          uniqueIds.add(id);
        }
      });

      return Array.from(uniqueIds);
    },
  },
  cell: props => <TagsCell {...props} tagStyle={tagStyle} />,
});

export const TagsCell: DatatableCellRenderer<Array<TagBase>, { tagStyle?: TagStyle }> = ({
  getValue,
  tagStyle,
}) => {
  const tags = getValue();
  return <HourTags tags={tags} className={styles.tags} tagStyle={tagStyle} />;
};
